import { en, type Key } from './en.js';
import { ru } from './ru.js';
import { uk } from './uk.js';

export type { Key };
export type Lang = 'en' | 'ru' | 'uk';
export const catalogs: Record<Lang, Record<Key, string>> = { en, ru, uk };

/** The first of the browser's languages we have; English otherwise. No switch on the page. */
export function pickLang(preferred: readonly string[]): Lang {
  for (const tag of preferred) {
    const base = tag.toLowerCase().split('-')[0];
    if (base === 'ru' || base === 'uk' || base === 'en') return base;
  }
  return 'en';
}

export const lang: Lang = pickLang(typeof navigator === 'undefined' ? [] : navigator.languages ?? [navigator.language]);

/** A whole phrase with {params} filled in. */
export function t(key: Key, params: Record<string, string | number> = {}): string {
  const text = catalogs[lang][key] ?? en[key];
  return text.replace(/\{(\w+)\}/g, (_, name: string) => (name in params ? String(params[name]) : `{${name}}`));
}

/** A list of names in the page language: "a, b and c". */
export function list(items: string[]): string {
  return new Intl.ListFormat(lang, { style: 'long', type: 'conjunction' }).format(items);
}

/** A whole phrase with one {param} rendered as an element (a chip, a link) in its place. */
export function around<T>(key: Key, param: string, node: T): [string, T, string] {
  const [before = '', after = ''] = t(key, { [param]: '\u0000' }).split('\u0000');
  return [before, node, after];
}
